module.exports = __webpack_public_path__ + "static/media/One side Angle's Class III 16.21ed0f19.png";